<script>

export default {
  name: 'PrivacyPolicy'
}
</script>

<template lang="pug" src="./PrivacyPolicy.pug"></template>
